import { type Style } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { Title, Subtitle } from '@app/components/core/typography/Title'

export type LandingContentTitleProps = {
  badge: string
  title: string
  subtitle?: string
  isCard?: boolean
  style?: Style
}

const LandingContentTitle = ({
  badge,
  title,
  subtitle,
  isCard = false,
  style,
}: LandingContentTitleProps) => {
  return (
    <Column
      style={{
        gap: isCard ? '0.5rem' : '2rem',
        ...style,
      }}
    >
      <Text.Small
        isBold
        style={{
          backgroundColor: 'var(--brand-accent)',
          padding: '0.25rem 1rem',
          borderRadius: '1.75rem',
        }}
      >
        {badge}
      </Text.Small>
      <Title.H2 style={{ marginBottom: 0 }}>{title}</Title.H2>
      {subtitle && <Subtitle style={{ marginBottom: 0 }}>{subtitle}</Subtitle>}
    </Column>
  )
}

export default LandingContentTitle
